<template>
  <div class="specialist-card">
    <TemplateCard
      v-if="skeleton"

      :appearance="appearance"
      :skeleton="skeleton"
    />

    <TemplateCard
      v-else

      @clickAction="$emit('showBooking', specialist)"
      @clickSubAction="$emit('showServices', { index, specialist })"

      :appearance="appearance"
      :highlight="false"

      cardActionType="gradient"
      cardActionValue="Programare nouă"
      cardSubActionType="secondary"
      cardSubActionValue="Vezi serviciile"

      :cardList="[
        { icon: 'fa-handshake'   , title: 'Număr ședințe', value: `${ specialist.services_count } ședințe` },
        { icon: 'fa-clock', title: 'Timp total'   , value: `${ timeTotal } min`  }
      ]"

      :specialistId="specialist.id"
      :spacialistName="specialist.full_name"
      :specialistTitle="specialist.title"
      :specialistAvatar="specialist.image_url"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TemplateCard   from './TemplateCard';

export default {
  components: { TemplateCard },
  props: [ 'appearance', 'index', 'skeleton', 'specialist' ],
  computed: {
    ...mapGetters({
      servicesBreak    : 'services/servicesBreak',
      servicesDuration : 'services/servicesDuration',
    }),

    timeTotal() {
      return this.specialist.services_count * this.servicesDuration;
    }
  },
}
</script>

<style lang="scss" scoped>
.specialist-card {
  padding: 10px;
}
</style>
